export default "__VITE_ASSET__BPFcgEJW__"